import * as React from 'react';
import { Page, Grid, Card, Button, Text } from 'tabler-react';
import PageComponent from '../PageComponent';

class TicketIndex extends PageComponent {
  state = {};

  render() {
    return (
      <Page.Content className="ticket">
        <Grid.Row cards>
          <Grid.Col xl={12}>
            <Card>
              <Card.Header>
                <Card.Title>邮件支持</Card.Title>
                <Card.Options>
                  <Button
                    color="success"
                    size="sm"
                    RootComponent="a"
                    href="mailto:hi@getmalus.com"
                    target="_blank">
                    <Text color="white">发送支持邮件</Text>
                  </Button>
                </Card.Options>
              </Card.Header>
              <Card.Body>一般回复时间24小时内，一定会回复</Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>

        <Grid.Row cards>
          <Grid.Col xl={12}>
            <Card>
              <Card.Header>
                <Card.Title>工单支持</Card.Title>
                <Card.Options>
                  <Button
                    color="success"
                    size="sm"
                    RootComponent="a"
                    href="/report"
                    target="_blank">
                    <Text color="white">发送工单</Text>
                  </Button>
                </Card.Options>
              </Card.Header>
              <Card.Body>
                VIP回复12小时内，一般会员48小时内，一定会回复
              </Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>

        <Grid.Row cards>
          <Grid.Col xl={12}>
            <Card>
              <Card.Header>
                <Card.Title>QQ群支持</Card.Title>
                <Card.Options>
                  <Button
                    color="success"
                    size="sm"
                    RootComponent="a"
                    href="/r/qqgroup"
                    target="_blank">
                    <Text color="white">加入QQ群</Text>
                  </Button>
                </Card.Options>
              </Card.Header>
              <Card.Body>在线随时支持，留言多可能会漏掉</Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>
      </Page.Content>
    );
  }
}

export default TicketIndex;
